<template>
  <div class="TabFooterBox">
    <div class="tab">
      <div
        v-for="(e, index) in tabList"
        :key="index"
        :class="`${e.id === tabId ? 'active' : ''} tabItem`"
        @click="switchClick(e.id)"
      >
        {{ e.name }}
      </div>
    </div>
    <div class="footer">
      <div class="dataTip" v-if="!tableData || tableData.length <= 0">
        <i
          class="iconfont icon-kongzhuangtai-icon"
          style="font-size:60px;margin-top:40px;"
        ></i>
        <p>什么都没有，快去算一下。</p>
      </div>
      <div class="table_head" v-if="!!tableData && tableData.length > 0">
        <p>
          贷款利息： <span>{{ toThousands(interest_tot) }}元</span>
        </p>
        <p style="margin: 0 16px; height: 1px; background: #DADADA"></p>
        <p>
          贷款本息： <span>{{ toThousands(repayment_tot) }}元</span>
        </p>
        <p style="height: 7px; background: #f8f8f9;"></p>
        <p>
          还款详情：
          <span
            style="font-family: PingFangSC-Regular;font-size: 10px;color: #C5CCDB;"
            >最终还款明细以银行贷款合同为准</span
          >
        </p>
      </div>
      <div class="on card" v-if="!!tableData && tableData.length > 0">
        <table
          border="0px"
          cellspacing="0"
          width="100%"
          id="thefirstpage"
          class="styleTable"
        >
          <tr>
            <th class="th1" style="">期数</th>
            <th class="th2">
              还款利息(元)
            </th>
            <th class="th2">
              还款本金(元)
            </th>
            <th class="th2">
              还款本息(元)
            </th>
          </tr>
          <div class="lines"></div>
          <tr v-for="(item, index) in tableData" :key="index">
            <td class="th1">{{ index * 1 + 1 }}/{{ tableData.length }}期</td>
            <td class="th2">
              {{ item.interest_a }}
            </td>
            <td class="th2">
              {{ item.capital }}
            </td>
            <td class="th2">
              {{ item.repayment_a }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { DoMath } from '../utils';
import bus from '../utils/bus';

export default {
  name: 'TabFooter',
  data() {
    return {
      tabId: '0',
      interest_tot: '0',
      repayment_tot: '0',
      tabList: [
        {
          name: '等额本息',
          id: '0',
        },
        {
          name: '等本等息',
          id: '1',
        },
        {
          name: '等额本金',
          id: '2',
        },
        {
          name: '每月付息一次还本',
          id: '3',
        },
      ],
      tableData: null,
    };
  },
  mounted() {
    bus.$on('getTableData', (data) => {
      this.getTableData(data);
    });
  },
  methods: {
    switchClick(id) {
      this.tabId = id;
      bus.$emit('switchClick', this.tableData);
    },
    toThousands(num) {
      return parseFloat(num)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },
    getTableData(data) {
      const TableData = DoMath(
        data.amount,
        data.timeNumber,
        this.tabId,
        data.rate,
      );
      this.tableData = TableData.newArr;
      this.interest_tot = TableData.interest_tot;
      this.repayment_tot = TableData.repayment_tot;
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
  text-align: left;
}
.th1 {
  max-width: 62px;
  min-width: 62px;
  display: inline-block;
  overflow: auto;
  word-wrap: break-word;
  word-break: break-all;
  padding: 0 5px;
  box-sizing: border-box;
  font-weight: bold;
}
.th2 {
  max-width: 100px;
  min-width: 100px;
  display: inline-block;
  overflow: auto;
  word-wrap: break-word;
  word-break: break-all;
  padding: 0 5px;
  box-sizing: border-box;
  font-weight: bold;
}
.table_head > p {
  height: 50px;
  line-height: 50px;
  padding: 0 16px;
  font-family: PingFangSC-Medium;
  color: #1c2438;
  font-size: 14px;
}
.tab {
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
}
.tab .tabItem {
  float: left;
  height: 30px;
  color: #6a7388;
  line-height: 30px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  border: 0;
}
.tab .active {
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #1c2438;
  border-bottom: 3px solid #f55646;
}
tr {
  margin: 0;
  padding: 6px 0;
  list-style: none;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
}
table {
  padding: 0 6px;
  font-size: 14px;
}
.lines {
  border-top: 1px solid #dadada;
}
.dataTip {
  margin-top: 50px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ccc;
  letter-spacing: 0;
}
.dataTip p {
  text-align: center;
  margin: 20px;
  padding-bottom: 100px;
}
</style>
